var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEducationIcn = function SvgEducationIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7388AE",
    d: "M22.063 20.543 15.5 24.235l-6.563-3.692v-3.9l-1.874-1.041v6.038l8.437 4.746 8.438-4.746v-6.038l-1.875 1.041v3.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7388AE",
    d: "M15.5 2.695 2.375 9.501v1.625L15.5 18.417l11.25-6.25v5.178h1.875V9.501L15.5 2.695Zm9.375 8.37L23 12.104l-7.5 4.168L8 12.106l-1.875-1.042-1.3-.722L15.5 4.807l10.674 5.535-1.299.722Z"
  })));
};
export default SvgEducationIcn;